import * as React from 'react';
import { makeStyles, createStyles, Typography } from '@material-ui/core';
import { FormikProps } from 'formik';
import cn from 'classnames';
import AlertBase from './AlertBase';
import { TranquiTheme } from '../../containers/App/theme';
import { NegotiationOption, NegotiationOptionAlternative, OutDebt } from '../../generated/graphql';
import FormikCheck from '../FormikInputWrappers/FormikCheck';
import RenderText from '../../dictionaries/RenderText';
import { pluralize } from '../../utils/pluralize';
import { formatIRate } from '../../utils/formatIRate';
import { getNegBooleans } from '../../utils/getNegBooleans';

interface CancelObligationRestrictionProps {
  negotiation?: NegotiationOption;
  alternative?: NegotiationOptionAlternative;
  formik?: FormikProps<any>;
  outDebt?: OutDebt;
}

const CancelObligationRestriction: React.FC<CancelObligationRestrictionProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const { negotiation, formik, outDebt, alternative } = props;
  const childrenDebtsLength = outDebt?.extra?.children?.length || 1;
  const monthlyRate = negotiation?.rate || outDebt?.rate || 0.007;

  const { isNormalization, isACPK, isBeta, isBogota } = getNegBooleans(outDebt, negotiation);

  if (!negotiation) return null;

  let message = isNormalization ? (
    <RenderText textKey="alert_cancelObligationRectiction_content_normalization" isMarkdown />
  ) : (
    <>
      Al realizar un acuerdo de pago de cartera, se
      {' '}
      <strong>cancela{pluralize(childrenDebtsLength, 'n')} la{pluralize(childrenDebtsLength)} deuda{pluralize(childrenDebtsLength)} castigada{pluralize(childrenDebtsLength)}</strong>
      {' '}
      y se crea un número de crédito diferente con una tasa del
      {' '}
      {formatIRate(monthlyRate, 'm')}
      {' '}
      (equivalente a {formatIRate(monthlyRate, 'y')}) y un plazo de {alternative?.term} meses.
    </>
  );

  const productNumbers = outDebt?.extra?.children?.map((child) => child.productNumber).join(' - ') || outDebt?.productNumber || '';
  if (isBeta || isBogota) message = <RenderText isMarkdown textKey="alert_cancelObligationRectiction_content" context={{ productNumbers }} />;

  return (
    <AlertBase
      type={formik?.values.cancelCheckbox ? 'rectictionsAccepted' : 'restrictions'}
      className={cn(classes.root, 'mb-2')}
      dataTest="cy-cancelObligation-restriction"
      title={isACPK ? 'Tener en cuenta que' : ''}
    >
      {message}
      {!!formik
        && (
        <FormikCheck
          className="mb-n2"
          formik={formik}
          valueId="cancelCheckbox"
          iconClassName={classes.iconCheckBox}
          helperTextClassName="mb-2"
          labelCheck={(
            <Typography className={classes.checkBoxText}>
              {isNormalization
                ? <RenderText textKey="alert_cancelObligationRectiction_formik_normalization" />
                : <RenderText textKey="alert_cancelObligationRectiction_formik" />}
            </Typography>
          )}
        />
        )}
    </AlertBase>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {

  },
  checkBox: {
    padding: theme.spacing(-1, 0),
  },
  checkBoxText: {
    ...theme.typography.body2,
  },
  iconCheckBox: {
    width: '0.8em',
    height: '0.8em',
  },
}));

export default CancelObligationRestriction;
